import React, { useState } from 'react';
import AuthModal from './components/AuthModal';
import ChatUI from './components/ChatUI';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  return (
    <div className="app">
      {!isAuthenticated && <AuthModal onLogin={handleLogin} />}
      <ChatUI />
    </div>
  );
}

export default App;
